import { z } from "zod";

export const upsertDiscountSchema = z
  .object({
    id: z.string().optional(),
    code: z.string().trim().min(3).max(30),
    type: z.enum(["PERCENT", "FIXED"]),
    value: z.number().int().positive(),
    minSubtotal: z.number().int().min(0).optional(),
    maxRedemptions: z.number().int().positive().nullable().optional(),
    isActive: z.boolean().optional(),
    expiresAt: z.string().datetime().nullable().optional()
  })
  .refine((data) => data.type !== "PERCENT" || data.value <= 100, {
    message: "Percent discounts must be between 1 and 100",
    path: ["value"]
  });
export type UpsertDiscountInput = z.infer<typeof upsertDiscountSchema>;

export const validateDiscountSchema = z.object({
  code: z.string().trim().min(1),
  subtotal: z.number().int().min(0)
});
export type ValidateDiscountInput = z.infer<typeof validateDiscountSchema>;
